const buildExample = (baseDir, fileName, title, section = 'robot-code') => ({
    id: `${baseDir}/${fileName}`,
    title,
    assetPath: `static/examples/extreme/${baseDir}/${section}/${fileName}`
});

const EXTREME_EXAMPLE_CATEGORIES = [
    {
        id: 'X1',
        title: 'X1',
        items: [
            buildExample('XROBO_Extreme_X1_v250930', 'x1-all-v260610.xc', '전체 코드', 'school-code'),
            buildExample('XROBO_Extreme_X1_v250930', 'x1-01-v250930.xc', '01 윈디'),
            buildExample('XROBO_Extreme_X1_v250930', 'x1-02-v250930.xc', '02 엑스휴먼'),
            buildExample('XROBO_Extreme_X1_v250930', 'x1-03-v250930.xc', '03 엑스쿠터'),
            buildExample('XROBO_Extreme_X1_v250930', 'x1-04-v250930.xc', '04 건틀렛'),
            buildExample('XROBO_Extreme_X1_v250930', 'x1-05-v250930.xc', '05 쫑이'),
            buildExample('XROBO_Extreme_X1_v250930', 'x1-06-v250930.xc', '06 물방개'),
            buildExample('XROBO_Extreme_X1_v250930', 'x1-07-v250930.xc', '07 이티'),
            buildExample('XROBO_Extreme_X1_v250930', 'x1-08-v250930.xc', '08 에프오'),
            buildExample('XROBO_Extreme_X1_v250930', 'x1-09-v250930.xc', '09 크래미'),
            buildExample('XROBO_Extreme_X1_v250930', 'x1-10-v250930.xc', '10 알씨'),
            buildExample('XROBO_Extreme_X1_v250930', 'x1-11-v250930.xc', '11 닌자'),
            buildExample('XROBO_Extreme_X1_v250930', 'x1-12-v250930.xc', '12 배트리')
        ]
    },
    {
        id: 'X2',
        title: 'X2',
        items: [
            buildExample('XROBO_Extreme_X2_v250930', 'x2-all-v260630.xc', '전체 코드', 'school-code'),
            buildExample('XROBO_Extreme_X2_v250930', 'x2-01-v260630.xc', '01 푸시'),
            buildExample('XROBO_Extreme_X2_v250930', 'x2-02-v250930.xc', '02 왕눈이'),
            buildExample('XROBO_Extreme_X2_v250930', 'x2-03-v250930.xc', '03 드로니'),
            buildExample('XROBO_Extreme_X2_v250930', 'x2-04-v250930.xc', '04 도토'),
            buildExample('XROBO_Extreme_X2_v250930', 'x2-05-v250930.xc', '05 스노우'),
            buildExample('XROBO_Extreme_X2_v250930', 'x2-06-v250930.xc', '06 스완'),
            buildExample('XROBO_Extreme_X2_v250930', 'x2-07-v250930.xc', '07 미니부스터'),
            buildExample('XROBO_Extreme_X2_v250930', 'x2-08-v250930.xc', '08 배틀X2'),
            buildExample('XROBO_Extreme_X2_v250930', 'x2-09-v250930.xc', '09 엑스리자드'),
            buildExample('XROBO_Extreme_X2_v250930', 'x2-10-v250930.xc', '10 히포'),
            buildExample('XROBO_Extreme_X2_v250930', 'x2-11-v250930.xc', '11 엑스사이클')
        ]
    },
    {
        id: 'X3',
        title: 'X3',
        items: [
            buildExample('XROBO_Extreme_X3_v250930', 'x3-all-v250930.xc', '전체 코드', 'school-code'),
            buildExample('XROBO_Extreme_X3_v250930', 'x3-01-v250930.xc', '01 라이플'),
            buildExample('XROBO_Extreme_X3_v250930', 'x3-02-v250930.xc', '02 엑스버기'),
            buildExample('XROBO_Extreme_X3_v250930', 'x3-03-v250930.xc', '03 땅강아지'),
            buildExample('XROBO_Extreme_X3_v250930', 'x3-04-v250930.xc', '04 피닉스'),
            buildExample('XROBO_Extreme_X3_v250930', 'x3-05-v250930.xc', '05 바이카'),
            buildExample('XROBO_Extreme_X3_v250930', 'x3-06-v250930.xc', '06 불도저'),
            buildExample('XROBO_Extreme_X3_v250930', 'x3-07-v250930.xc', '07 트레일러'),
            buildExample('XROBO_Extreme_X3_v250930', 'x3-08-v250930.xc', '08 킹콩'),
            buildExample('XROBO_Extreme_X3_v250930', 'x3-09-v250930.xc', '09 폭격기'),
            buildExample('XROBO_Extreme_X3_v250930', 'x3-10-v250930.xc', '10 배틀X3')
        ]
    },
    {
        id: 'X4',
        title: 'X4',
        items: [
            buildExample('XROBO_Extreme_X4_ascii', 'x4-all-submachine-v260630.xc', '전체 코드(서브머신)', 'school-code'),
            buildExample('XROBO_Extreme_X4_ascii', 'x4-all-x-cannon-v260728.xc', '전체 코드(X-캐논)', 'school-code'),
            buildExample('XROBO_Extreme_X4_ascii', 'x4-01-cyclone-v260414.sb3', '01 사이클론'),
            buildExample('XROBO_Extreme_X4_ascii', 'x4-02-barbarian-v260414.sb3', '02 바바리안'),
            buildExample('XROBO_Extreme_X4_ascii', 'x4-03-x-grab-v260414.sb3', '03 엑스그랩'),
            buildExample('XROBO_Extreme_X4_ascii', 'x4-04-tarantula-v260414.sb3', '04 타란튤라'),
            buildExample('XROBO_Extreme_X4_ascii', 'x4-05-battle-x4-v260414.sb3', '05 배틀X4'),
            buildExample('XROBO_Extreme_X4_ascii', 'x4-06-alligator-v260630.xc', '06 엘리게이터'),
            buildExample('XROBO_Extreme_X4_ascii', 'x4-07-offroader-v260414.sb3', '07 오프로더'),
            buildExample('XROBO_Extreme_X4_ascii', 'x4-08-submachine-v250930.xc', '08 서브머신'),
            buildExample('XROBO_Extreme_X4_ascii', 'x4-08-x-cannon-v260728.xc', '08 X-캐논')
        ]
    },
    {
        id: 'X5',
        title: 'X5',
        items: [
            buildExample('XROBO_Extreme_X5_v250930', 'x5-all-v250930.xc', '전체 코드', 'school-code'),
            buildExample('XROBO_Extreme_X5_v250930', 'x5-all-willy-renewal-v261030.xc', '전체 코드(윌리 리뉴얼)', 'school-code'),
            buildExample('XROBO_Extreme_X5_v250930', 'x5-01-v250930.xc', '01 윌리'),
            buildExample('XROBO_Extreme_X5_v250930', 'x5-01-willy-renewal-v261030.xc', '01 윌리(리뉴얼)'),
            buildExample('XROBO_Extreme_X5_v250930', 'x5-02-v250930.xc', '02 엑스벤틀리'),
            buildExample('XROBO_Extreme_X5_v250930', 'x5-03-v250930.xc', '03 트윈롤링'),
            buildExample('XROBO_Extreme_X5_v250930', 'x5-04-v250930.xc', '04 사이보그바이크'),
            buildExample('XROBO_Extreme_X5_v250930', 'x5-05-v250930.xc', '05 배틀X5'),
            buildExample('XROBO_Extreme_X5_v250930', 'x5-06-v250930.xc', '06 메카티라노')
        ]
    },
    {
        id: 'X6',
        title: 'X6',
        items: [
            buildExample('XROBO_Extreme_X6_v250930', 'x6-all-v250930.xc', '전체 코드', 'school-code'),
            buildExample('XROBO_Extreme_X6_v250930', 'x6-01-v250930.xc', '01 리버스'),
            buildExample('XROBO_Extreme_X6_v250930', 'x6-02-v250930.xc', '02 배틀X6'),
            buildExample('XROBO_Extreme_X6_v250930', 'x6-03-v250930.xc', '03 옵티머스'),
            buildExample('XROBO_Extreme_X6_v250930', 'x6-04-v250930.xc', '04 엑스부스터'),
            buildExample('XROBO_Extreme_X6_v250930', 'x6-05-v250930.xc', '05 몬스터'),
            buildExample('XROBO_Extreme_X6_v250930', 'x6-06-v250930.xc', '06 바이크론')
        ]
    },
    {
        id: 'XB',
        title: 'XB',
        items: [
            buildExample('XROBO_Extreme_XB_v250930', 'xb-all-v250930.xc', '전체 코드', 'school-code'),
            buildExample('XROBO_Extreme_XB_v250930', 'xb-01-v250930.xc', '01 스톰'),
            buildExample('XROBO_Extreme_XB_v250930', 'xb-02-v250930.xc', '02 더블카터'),
            buildExample('XROBO_Extreme_XB_v250930', 'xb-03-v250930.xc', '03 드럼스피너'),
            buildExample('XROBO_Extreme_XB_v250930', 'xb-04-v250930.xc', '04 히든스핀'),
            buildExample('XROBO_Extreme_XB_v250930', 'xb-05-v250930.xc', '05 전차'),
            buildExample('XROBO_Extreme_XB_v250930', 'xb-06-v250930.xc', '06 데스레이싱'),
            buildExample('XROBO_Extreme_XB_v250930', 'xb-07-v250930.xc', '07 디스크롤'),
            buildExample('XROBO_Extreme_XB_v250930', 'xb-08-v250930.xc', '08 배틀XB')
        ]
    },
    {
        id: 'XB2',
        title: 'XB2',
        items: [
            buildExample('XROBO_Extreme_XB2_ascii', 'xb2-all-v260702.xc', '전체 코드', 'school-code'),
            buildExample('XROBO_Extreme_XB2_ascii', 'xb2-01-battle-alpha-v260326.xc', '01 배틀-알파'),
            buildExample('XROBO_Extreme_XB2_ascii', 'xb2-02-twin-gatling-v260226.xc', '02 트윈 게틀링'),
            buildExample('XROBO_Extreme_XB2_ascii', 'xb2-03-x-roadroller-v260226.xc', '03 X-로드롤러'),
            buildExample('XROBO_Extreme_XB2_ascii', 'xb2-04-battle-beta-v260702.xc', '04 배틀-베타'),
            buildExample('XROBO_Extreme_XB2_ascii', 'xb2-05-king-ufa-v260410.xc', '05 킹우파'),
            buildExample('XROBO_Extreme_XB2_ascii', 'xb2-06-x-mantis-v260331.xc', '06 X-멘티스'),
            buildExample('XROBO_Extreme_XB2_ascii', 'xb2-07-battle-gamma-v260402.xc', '07 배틀-감마')
        ]
    },
    {
        id: 'SD_2x3pin',
        title: 'SD_2x3pin',
        items: [
            buildExample('XROBO_Extreme_SD_2x3pin_v250930', 'sd-2x3pin-01-03-v260522.xc', '전체 코드 01~03', 'school-code'),
            buildExample('XROBO_Extreme_SD_2x3pin_v250930', 'sd-2x3pin-04-06-v260522.xc', '전체 코드 04~06', 'school-code'),
            buildExample('XROBO_Extreme_SD_2x3pin_v250930', 'sd-2x3pin-07-08-v260522.xc', '전체 코드 07~08', 'school-code'),
            buildExample('XROBO_Extreme_SD_2x3pin_v250930', 'sd-2x3pin-01-v250930.xc', '01 엑스플립'),
            buildExample('XROBO_Extreme_SD_2x3pin_v250930', 'sd-2x3pin-02-v250930.xc', '02 트랜스덩크'),
            buildExample('XROBO_Extreme_SD_2x3pin_v250930', 'sd-2x3pin-03-v250930.xc', '03 히든다이스'),
            buildExample('XROBO_Extreme_SD_2x3pin_v250930', 'sd-2x3pin-04-v250930.xc', '04 어메이징무빙'),
            buildExample('XROBO_Extreme_SD_2x3pin_v250930', 'sd-2x3pin-05-v250930.xc', '05 터틀워치'),
            buildExample('XROBO_Extreme_SD_2x3pin_v250930', 'sd-2x3pin-06-v250930.xc', '06 나이트캣'),
            buildExample('XROBO_Extreme_SD_2x3pin_v250930', 'sd-2x3pin-07-v250930.xc', '07 히폰'),
            buildExample('XROBO_Extreme_SD_2x3pin_v250930', 'sd-2x3pin-08-v250930.xc', '08 앵글탱크')
        ]
    },
    {
        id: 'XW',
        title: 'XW',
        items: [
            buildExample('XROBO_Extreme_XW_v250930', 'xw-all-v260822.xc', '전체 코드', 'school-code'),
            buildExample('XROBO_Extreme_XW_v250930', 'xw-01-v250930.xc', '01 엑스파이터'),
            buildExample('XROBO_Extreme_XW_v250930', 'xw-02-v250930.xc', '02 사이보그핸드'),
            buildExample('XROBO_Extreme_XW_v250930', 'xw-03-v260804.xc', '03 컴비네이션F'),
            buildExample('XROBO_Extreme_XW_v250930', 'xw-04-v260707.xc', '04 컴비네이션R'),
            buildExample('XROBO_Extreme_XW_v250930', 'xw-05-v250930.xc', '05 롤링카'),
            buildExample('XROBO_Extreme_XW_v250930', 'xw-06-v260821.xc', '06 핸드슈트'),
            buildExample('XROBO_Extreme_XW_v250930', 'xw-07-v250930.xc', '07 F1'),
            buildExample('XROBO_Extreme_XW_v250930', 'xw-08-v250930.xc', '08 스페이스핸들'),
            buildExample('XROBO_Extreme_XW_v250930', 'xw-09-v260822.xc', '09 인터셉터'),
            buildExample('XROBO_Extreme_XW_v250930', 'xw-10-v250930.xc', '10 케리어머신'),
            buildExample('XROBO_Extreme_XW_v250930', 'xw-11-v250930.xc', '11 ATV'),
            buildExample('XROBO_Extreme_XW_v250930', 'xw-12-v260819.xc', '12 듀얼키패드')
        ]
    },
    {
        id: 'CP',
        title: 'CP',
        items: [
            buildExample('XROBO_Extreme_XCP', 'xcp-all.xc', '전체 코드', 'school-code'),
            buildExample('XROBO_Extreme_XCP', 'xcp-01-centipede.xc', '01 센티피드'),
            buildExample('XROBO_Extreme_XCP', 'xcp-02-skid-loader.xc', '02 스키드 로더'),
            buildExample('XROBO_Extreme_XCP', 'xcp-03-mecha-octopus.xc', '03 메카 옥토퍼스'),
            buildExample('XROBO_Extreme_XCP', 'xcp-04-battle-cp.xc', '04 배틀-CP'),
            buildExample('XROBO_Extreme_XCP', 'xcp-05-x-spirit.xc', '05 엑스피릿'),
            buildExample('XROBO_Extreme_XCP', 'xcp-06-snow-tracker.xc', '06 스노우 트래커'),
            buildExample('XROBO_Extreme_XCP', 'xcp-07-x-digger.xc', '07 X-디거'),
            buildExample('XROBO_Extreme_XCP', 'xcp-08-x-tank.xc', '08 X-탱크')
        ]
    }
];

export {EXTREME_EXAMPLE_CATEGORIES};
